import React from "react";

import "./LandingPage.css";
import { useNavigate } from "react-router-dom";

export const Header = (props) => {
  const navigate = useNavigate();
  return (
    <div className="landing-page">
      <h1 className="title">MyKalory</h1>
      <p className="subtitle">
        Effortlessly Track Calorie and Macro-Nutrient Intake
      </p>
      <div className="features">
        <div className="feature shadow-box">
          <div className="feature-img-padding">
            <img src="demo1.png" alt="Chart Icon" className="feature-img" />
          </div>
          <h2 className="feature-title">Seamless Tracking</h2>
          <p className="feature-description">
            Simply snap a photo of your meal, and MyKalory will automatically
            analyze it to provide you with detailed nutritional information.
          </p>
        </div>
        <div className="feature shadow-box">
          <div className="feature-img-padding">
            <img src="demo2.png" alt="Chart Icon" className="feature-img" />
          </div>
          <h2 className="feature-title">Comprehensive Analysis</h2>
          <p className="feature-description">
            Gain insights into your calorie and macro-nutrient consumption
            patterns with our comprehensive analysis tools. Understand your diet
            like never before.
          </p>
        </div>
      </div>
      <button className="cta-button" onClick={() => navigate("/user/main_feed")}>Get Started</button>
    </div>
  );
};
